const initialState = {
  // Getting Buyer Status Job
  isGettingBuyerStatusJob: false,
  hasLoadedBuyerStatusJob: false,
  buyerStatusJobError: "",
  // The update that is running, or null
  activeBuyerStatusJob: null,
  // The most recent one that has ended (completed / stopped / failed)
  lastBuyerStatusJob: null,
  buyerStatusJobHistory: [],
  // The taxpayer list the ATL Status is read from: { totalRows, fileName,
  // importedAt }, or null when none has been uploaded
  buyerStatusAtlDataset: null,

  // Running Buyer Status Job
  isStartingBuyerStatusJob: false,

  // Stopping Buyer Status Job
  isStoppingBuyerStatusJob: false,
};

const ProgramSettingsReducer = (state = initialState, action) => {
  switch (action.type) {
    // Getting Buyer Status Job
    case "BUYER_STATUS_JOB_REQUEST":
      return {
        ...state,
        isGettingBuyerStatusJob: true,
      };
    case "BUYER_STATUS_JOB_SUCCESS":
      return {
        ...state,
        activeBuyerStatusJob: action.payload?.active || null,
        lastBuyerStatusJob: action.payload?.last || null,
        buyerStatusJobHistory: action.payload?.history || [],
        buyerStatusAtlDataset: action.payload?.atlDataset || null,
        isGettingBuyerStatusJob: false,
        hasLoadedBuyerStatusJob: true,
        buyerStatusJobError: "",
      };
    case "BUYER_STATUS_JOB_ERROR":
      return {
        ...state,
        isGettingBuyerStatusJob: false,
        buyerStatusJobError: action.payload || "",
      };
    // Running Buyer Status Job
    case "RUN_BUYER_STATUS_JOB_REQUEST":
      return {
        ...state,
        isStartingBuyerStatusJob: true,
      };
    case "RUN_BUYER_STATUS_JOB_SUCCESS":
      return {
        ...state,
        // Shown as running at once, without waiting for the next status.
        activeBuyerStatusJob: action.payload?.active || state.activeBuyerStatusJob,
        isStartingBuyerStatusJob: false,
      };
    case "RUN_BUYER_STATUS_JOB_ERROR":
      return {
        ...state,
        isStartingBuyerStatusJob: false,
      };
    // Stopping Buyer Status Job
    case "STOP_BUYER_STATUS_JOB_REQUEST":
      return {
        ...state,
        isStoppingBuyerStatusJob: true,
      };
    case "STOP_BUYER_STATUS_JOB_SUCCESS":
      return {
        ...state,
        isStoppingBuyerStatusJob: false,
      };
    case "STOP_BUYER_STATUS_JOB_ERROR":
      return {
        ...state,
        isStoppingBuyerStatusJob: false,
      };
    default:
      return state;
  }
};

export default ProgramSettingsReducer;
